import { useState, useEffect } from "react"
import { Card, Button, Row, Col, Form } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import leadService from "../services/leadService"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import mainSpecialtyService from "../../main_specialty/services/main_specialtyService"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/bootstrap.css"

function LeadForm() {
  const [loading, setLoading] = useState(false)
  const [initialLoading, setInitialLoading] = useState(false)
  const navigate = useNavigate()
  const { id } = useParams()
  const [leadData, setLeadData] = useState({
    name: "",
    last_name: "",
    origin: "", // <-- ADDED
    estimated_value: "", // <-- ADDED (initialize as string for form input)
    email: "", // <-- ADDED
    phone_number: "", // <-- ADDED
    commentary: "", // <-- ADDED
    main_specialty: "", // <-- ADDED
    specialty: "", // <-- ADDED (for sub-specialty)
    province: "", // <-- ADDED
    online_service: false,
    sms_verified: false,
    email_verified: false,
  })
  const [Specialty, setSpecialty] = useState([])
  const [mainSpecialty, setMainSpecialty] = useState([])
  const [Province, setProvince] = useState([])

  const getFkId = (value) =>
    value == null
      ? ""
      : typeof value === "object"
      ? String(value.id) // coge el id si viene objeto
      : String(value) // ya era un id

  useEffect(() => {
    fetchAll()
  }, [id])

  const fetchAll = async () => {
    try {
      setInitialLoading(true)
      await Promise.all([
        id && fetchLead(),
        fetchSpecialtyList(),
        fetchMain_specialty(),
        fetchProvinceList(),
      ])
    } catch (error) {
      console.error("Error fetching lead list:", error)
    } finally {
      setInitialLoading(false)
    }
  }
  const fetchMain_specialty = async () => {
    try {
      const specialty = await mainSpecialtyService.getMain_specialtyList()
      setMainSpecialty(specialty)
    } catch (error) {
      console.log("Error fetching specialty list:", error)
    }
  }

  const fetchSpecialtyList = async () => {
    try {
      const specialty = await leadService.getSpecialtyList()
      setSpecialty(specialty)
    } catch (error) {
      console.log("Error fetching specialty list:", error)
    }
  }

  const fetchProvinceList = async () => {
    try {
      const province = await leadService.getProvinceList()
      setProvince(province)
    } catch (error) {
      console.log("Error fetching province list:", error)
    }
  }

  const fetchLead = async () => {
    try {
      const lead = await leadService.getLeadDetails(id)
      console.log("Fetched lead details from API:", lead) // Keep this for now if you still need to debug other fields

      // Prepare the data to be set into the state
      const newData = {
        // Spread all properties from the fetched lead first
        // This ensures any fields from the API not explicitly listed below are still included
        // if your initialLeadData state doesn't have them all
        ...leadData, // Start with existing/initial leadData structure
        ...lead, // Overlay with ALL fetched data

        // Explicitly handle fields that need transformation or default values
        name: lead.name || "",
        last_name: lead.last_name || "",
        origin: lead.origin || "",
        // Handle estimated_value if it exists on the lead object, otherwise default.
        // If 'estimated_value' is not part of your 'lead' object from API, this will take leadData.estimated_value or ""
        estimated_value:
          lead.estimated_value !== undefined && lead.estimated_value !== null
            ? String(lead.estimated_value)
            : leadData?.estimated_value || "", // Fallback to existing or ""
        email: lead.email || "",
        phone_number: lead.phone_number || "",
        commentary: lead.commentary || "",
        online_service: lead.online_service || false,
        sms_verified: lead.sms_verified || false, // Assuming sms_verified is boolean in API
        email_verified: lead.email_verified || false, // Assuming email_verified is boolean in API

        // Correctly set the IDs for the dropdowns, converting to string
        // as select values are typically strings, and API might give numbers.
        main_specialty:
          lead.main_specialty !== null && lead.main_specialty !== undefined
            ? getFkId(lead.main_specialty)
            : "",
        province:
          lead.province !== null && lead.province !== undefined
            ? getFkId(lead.province)
            : "",
        specialty:
          lead.specialty !== null && lead.specialty !== undefined // This is for sub-specialty
            ? getFkId(lead.specialty)
            : "",
      }

      console.log("Data being set into leadData state:", newData) // Log what's actually being set
      setLeadData(newData)
    } catch (error) {
      console.log("Error fetching lead:", error)
      // Consider resetting form or showing error to user
    }
  }

  const handleChange = (event) => {
    setLeadData({ ...leadData, [event.target.name]: event.target.value })
  }
  const handleCheck = (event) => {
    setLeadData({ ...leadData, [event.target.name]: event.target.checked })
  }

  const handleCreateOrUpdateLead = async (event) => {
    event.preventDefault()

    try {
      setLoading(true)
      if (id) {
        console.log("Updating lead:", leadData)
        await leadService.updateLead(id, leadData)
      } else {
        await leadService.createLead(leadData)
      }
      navigate("/lead")
    } catch (error) {
      console.log("Error creating/updating lead:", error)
    } finally {
      setLoading(false)
    }
  }

  const pageTitle = id ? "Editar Lead" : "Añadir Lead"
  const submitButtonText = id ? "Actualizar" : "Guardar"

  return (
    <Layout title={pageTitle} content="container" loading={initialLoading}>
      <Block>
        <Card className="card-gutter-md">
          <Card.Body>
            <div className="bio-block">
              <h4 className="bio-block-title mb-4">{pageTitle}</h4>

              <Form onSubmit={handleCreateOrUpdateLead}>
                <Row className="g-3">
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="name">Nombre</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="text"
                          id="name"
                          placeholder="Nombre"
                          name="name"
                          value={leadData?.name || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="last_name">Apellido</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="text"
                          id="last_name"
                          placeholder="Apellido"
                          name="last_name"
                          value={leadData?.last_name}
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="origin">Origen</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="text"
                          id="origin"
                          placeholder="Origen"
                          name="origin"
                          value={leadData?.origin || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  {/* add estimated_value field (decimal with 2 decimal places) */}
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="estimated_value">
                        Valor estimado
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="number"
                          id="estimated_value"
                          placeholder="Valor estimado"
                          name="estimated_value"
                          value={leadData?.estimated_value || ""}
                          onChange={handleChange}
                          step={0.01}
                          max={99999999.99}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="email">
                        Correo electrónico
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          type="text"
                          id="email"
                          placeholder="Correo electrónico"
                          name="email"
                          value={leadData?.email || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                  <Form.Group className="form-group">
                    <Form.Label htmlFor="phone_number">
                      Número de teléfono
                    </Form.Label>
                    <div className="form-control-wrap">
                      <PhoneInput
                        country="es"                           
                        preferredCountries={["es", "fr", "gb"]}
                        value={leadData.phone_number.replace("+", "")}
                        onChange={(value, data) =>
                          setLeadData({
                            ...leadData,
                            phone_number: "+" + value,
                            phone_country: data.countryCode,
                          })
                        }
                        inputProps={{
                          name: "phone_number",
                          id: "phone_number",
                          required: true,
                        }}
                        containerClass="react-phone-container"
                        inputClass="react-phone-input"
                        buttonClass="react-phone-button"
                      />
                    </div>
                  </Form.Group>
                </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="commentary">Comentario</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          as="textarea"
                          rows={10}
                          id="commentary"
                          name="commentary"
                          value={leadData?.commentary || ""}
                          onChange={handleChange}
                          style={{ whiteSpace: "pre-wrap" }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="main_specialty">
                        Especialidad
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Select
                          id="main_specialty"
                          name="main_specialty"
                          value={leadData?.main_specialty || ""}
                          onChange={handleChange}
                          className="custom-select"
                        >
                          <option value="">Seleccionar especialidad</option>
                          {mainSpecialty?.map((specialtyItem, idx) => {
                            return (
                              <option
                                key={specialtyItem.id || idx}
                                value={specialtyItem.id}
                              >
                                {specialtyItem.name}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="specialty">
                        Subespecialidad
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Select
                          id="specialty"
                          name="specialty"
                          value={leadData?.specialty || ""}
                          onChange={handleChange}
                          className="custom-select"
                        >
                          <option value="">Seleccionar subespecialidad</option>
                          {Specialty?.map((subSpecialtyItem, idx) => {
                            return (
                              <option
                                key={subSpecialtyItem.id || idx}
                                value={subSpecialtyItem.id}
                              >
                                {subSpecialtyItem.child_specialty}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="province">Provincia</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Select
                          id="province"
                          name="province"
                          value={leadData?.province || ""}
                          onChange={handleChange}
                          className="custom-select"
                        >
                          <option value="">Seleccionar provincia</option>
                          {Province?.map((provinceItem) => (
                            <option
                              key={provinceItem.id}
                              value={provinceItem.id}
                            >
                              {provinceItem.name}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="Lead_state">Lead_state</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Select
                          id="state"
                          name="state"
                          value={leadData?.state}
                          onChange={handleChange}
                          className="custom-select"
                        >
                          <option value="">Select Lead_state</option>
                          {Lead_state?.map((lead_state, idx) => {
                            return (
                              <option key={idx} value={lead_state.id}>
                                {lead_state.state}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col> */}

                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Check
                        type="checkbox"
                        id="online_service"
                        name="online_service"
                        checked={leadData?.online_service}
                        label="Servicio en línea"
                        onChange={handleCheck}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Check
                        type="checkbox"
                        id="sms_verified"
                        name="sms_verified"
                        checked={leadData?.sms_verified}
                        label="Verificado por SMS"
                        onChange={handleCheck}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Form.Group className="form-group">
                      <Form.Check
                        type="checkbox"
                        id="email_verified"
                        name="email_verified"
                        checked={leadData?.email_verified}
                        label="Verificado por correo electrónico"
                        onChange={handleCheck}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="12">
                    <Button variant="primary" type="submit">
                      {loading ? "loading..." : submitButtonText}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Card.Body>
        </Card>
      </Block>
    </Layout>
  )
}

export default LeadForm
